import { Timezone, TIMEZONES } from '@snagajob/angular/types/time-zones';

export class TimezoneArray extends Array<Timezone> {
  private static timezones: Timezone[] = TIMEZONES;

  // Get Timezone
  public static getTimezone(timezoneValue: string): Timezone {
    return this.timezones.find((tz: Timezone) => tz.value === timezoneValue);
  }

  public static getTimezoneFromEnum(timezoneEnum: number): Timezone {
    return this.timezones.find((tz: Timezone) => tz.enumValue === timezoneEnum);
  }

  public static getTimezoneAbbr(timeZoneValue: string): string {
    return (
      this.timezones.find((tz: Timezone) => tz.value === timeZoneValue)?.abbr ??
      new Date()
        .toLocaleTimeString('en-us', {
          timeZone: timeZoneValue,
          timeZoneName: 'short',
        })
        ?.split(' ')[2]
    );
  }
}
